var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5233 8.94114H8.54418L13.1921 13.5891C13.3698 13.7667 13.6621 13.7811 13.8448 13.6091C14.983 12.5367 15.7659 11.0911 15.9957 9.46614C16.0351 9.18791 15.8042 8.94114 15.5233 8.94114ZM15.0577 7.03526C14.8154 3.52173 12.0077 0.714089 8.49418 0.471736C8.22595 0.453207 8.00006 0.679383 8.00006 0.948206V7.52938H14.5815C14.8504 7.52938 15.0762 7.3035 15.0577 7.03526ZM6.5883 8.94114V1.96203C6.5883 1.68115 6.34153 1.45026 6.06359 1.48968C2.55859 1.98497 -0.120524 5.04703 0.00418193 8.71673C0.132417 12.4856 3.37742 15.5761 7.14801 15.5288C8.63036 15.5103 10.0001 15.0326 11.1262 14.2338C11.3586 14.0691 11.3739 13.727 11.1724 13.5256L6.5883 8.94114Z",
    fill: "#D4E8FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.bc0c49ae430a8408739ec33e376e889a.svg";
export { ForwardRef as ReactComponent };